import { initLazyScript } from '../utils/theme-functions.js';

class CountdownTimer extends HTMLElement {
    constructor() {
        super();
        this.endDate = new Date(this.dataset.endDate).getTime();
        console.log('setting enddate', this.endDate);
        if (!Number(this.endDate)) return;

        initLazyScript(this, this.init.bind(this));
    }

    init() {
        this.daysEl = this.querySelector('.js-days');
        this.hoursEl = this.querySelector('.js-hours');
        this.minsEl = this.querySelector('.js-mins');
        this.secsEl = this.querySelector('.js-secs');

        this.second = 1000;
        this.minute = 60 * this.second;
        this.hour = 60 * this.minute;
        this.day = 24 * this.hour;

        this.timer();
        this.interval = setInterval(this.timer.bind(this), this.second);
    }

    timer() {
        const timeDiff = this.endDate - new Date();

        if (timeDiff < 0) {
            clearInterval(this.interval);
            return;
        }

        const days = Math.floor(timeDiff / this.day);
        const hours = Math.floor(timeDiff / this.hour);
        const mins = Math.floor(timeDiff / this.minute);
        const secs = Math.floor(timeDiff / this.second);

        const formatTime = (num) => String(num).padStart(2, '0');

        if (this.daysEl) {
            this.daysEl.textContent = formatTime(days);
        }
        if (this.hoursEl) {
            this.hoursEl.textContent = formatTime(hours - days * 24);
        }
        if (this.minsEl) {
            this.minsEl.textContent = formatTime(mins - hours * 60);
        }
        if (this.secsEl) {
            this.secsEl.textContent = formatTime(secs - mins * 60);
        }
    }
}

customElements.define('countdown-timer', CountdownTimer);
